/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../constants/ServiceConstants';
import * as textConstants from '../../constants/StudioTextConstants';
import utils from '../../../../common/utils';

/**
 * GetUploadedContentService - Fetches uploaded content for Content Drawer
 * API: GET /api/v2.0/upload/content?userId=xxx
 */
export default class GetUploadedContentService extends BaseService {
  constructor() {
    super(constants.GET_UPLOADED_CONTENT, 'getUploadedContentStatus');
  }

  getErrorMessage(data, fallback) {
    return data?.error || data?.message || fallback;
  }

  handleEvent(eventName, event) {
    const { payload, headers } = utils.buildRequestPartsFromPayload(event);
    const { userId } = payload;

    return this.getClient('aiadminv2').get(`/upload/content?userId=${encodeURIComponent(userId)}`, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data && data.success) {
      Framework.getStoreRegistry().getStore('contentUploadModel').setContents(data.data);
      Framework.getEventManager().publish(constants.GET_UPLOADED_CONTENT_SUCCESS, { data: data.data });
    } else {
      const msg = this.getErrorMessage(data, textConstants.GET_CONTENT_FAILED_MSG);
      Framework.getStoreRegistry().getStore('contentUploadModel').setLoadError(msg);
      Framework.getEventManager().publish(constants.GET_UPLOADED_CONTENT_ERROR);
    }
  }

  handleError(error) {
    const { response } = error;
    let msg = textConstants.GET_CONTENT_REQUEST_FAILED_MSG;

    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
        Framework.getEventManager().publish(constants.GET_UPLOADED_CONTENT_ERROR);
        return;
      }
      msg = this.getErrorMessage(data, msg);
    } else if (error.message === `timeout of ${constants.BERLIN_API_TIMEOUT}ms exceeded`) {
      msg = 'Request timeout. Please try again.';
    }

    Framework.getStoreRegistry().getStore('contentUploadModel').setLoadError(msg);
    Framework.getEventManager().publish(constants.GET_UPLOADED_CONTENT_ERROR);
  }
}
